/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  HangarGroup,
  HangarGroupCreateInput,
  HangarGroupSort200,
  HangarGroupSortInput,
  HangarGroupUpdateInput,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary HangarGroup create
 */
export const createHangarGroup = (
    hangarGroupCreateInput: MaybeRefOrGetter<HangarGroupCreateInput>,
 signal?: AbortSignal
) => {
      hangarGroupCreateInput = toValue(hangarGroupCreateInput);

      return axiosClient<HangarGroup>(
      {url: `/hangar/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hangarGroupCreateInput, signal
    },
      );
    }




export const getCreateHangarGroupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarGroup>>, TError,{data: HangarGroupCreateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createHangarGroup>>, TError,{data: HangarGroupCreateInput}, TContext> => {

const mutationKey = ['createHangarGroup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHangarGroup>>, {data: HangarGroupCreateInput}> = (props) => {
          const {data} = props ?? {};

          return  createHangarGroup(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHangarGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createHangarGroup>>>
    export type CreateHangarGroupMutationBody = HangarGroupCreateInput
    export type CreateHangarGroupMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary HangarGroup create
 */
export const useCreateHangarGroup = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarGroup>>, TError,{data: HangarGroupCreateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createHangarGroup>>,
        TError,
        {data: HangarGroupCreateInput},
        TContext
      > => {
      return useMutation(getCreateHangarGroupMutationOptions(options), queryClient);
    }
    /**
 * @summary HangarGroup list
 */
export const hangarGroups = (

 signal?: AbortSignal
) => {


      return axiosClient<HangarGroup[]>(
      {url: `/hangar/groups`, method: 'GET', signal
    },
      );
    }




export const getHangarGroupsQueryKey = () => {
    return [
    'hangar','groups'
    ] as const;
    }


export const getHangarGroupsQueryOptions = <TData = Awaited<ReturnType<typeof hangarGroups>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarGroups>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarGroups>>> = ({ signal }) => hangarGroups(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarGroups>>, TError, TData>
}

export type HangarGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof hangarGroups>>>
export type HangarGroupsQueryError = ErrorType<StandardError>


/**
 * @summary HangarGroup list
 */

export function useHangarGroups<TData = Awaited<ReturnType<typeof hangarGroups>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarGroups>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary HangarGroup sort
 */
export const hangarGroupSort = (
    hangarGroupSortInput: MaybeRefOrGetter<HangarGroupSortInput>,
 signal?: AbortSignal
) => {
      hangarGroupSortInput = toValue(hangarGroupSortInput);

      return axiosClient<HangarGroupSort200>(
      {url: `/hangar/groups/sort`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: hangarGroupSortInput, signal
    },
      );
    }




export const getHangarGroupSortMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hangarGroupSort>>, TError,{data: HangarGroupSortInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof hangarGroupSort>>, TError,{data: HangarGroupSortInput}, TContext> => {

const mutationKey = ['hangarGroupSort'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hangarGroupSort>>, {data: HangarGroupSortInput}> = (props) => {
          const {data} = props ?? {};

          return  hangarGroupSort(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HangarGroupSortMutationResult = NonNullable<Awaited<ReturnType<typeof hangarGroupSort>>>
    export type HangarGroupSortMutationBody = HangarGroupSortInput
    export type HangarGroupSortMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary HangarGroup sort
 */
export const useHangarGroupSort = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hangarGroupSort>>, TError,{data: HangarGroupSortInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof hangarGroupSort>>,
        TError,
        {data: HangarGroupSortInput},
        TContext
      > => {
      return useMutation(getHangarGroupSortMutationOptions(options), queryClient);
    }
    /**
 * @summary HangarGroup Destroy
 */
export const destroyHangarGroup = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<HangarGroup>(
      {url: `/hangar/groups/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyHangarGroupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarGroup>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyHangarGroup>>, TError,{id: string}, TContext> => {

const mutationKey = ['destroyHangarGroup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyHangarGroup>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyHangarGroup(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyHangarGroupMutationResult = NonNullable<Awaited<ReturnType<typeof destroyHangarGroup>>>

    export type DestroyHangarGroupMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary HangarGroup Destroy
 */
export const useDestroyHangarGroup = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarGroup>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyHangarGroup>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDestroyHangarGroupMutationOptions(options), queryClient);
    }
    /**
 * @summary HangarGroup Update
 */
export const updateHangarGroup = (
    id: MaybeRefOrGetter<string>,
    hangarGroupUpdateInput: MaybeRefOrGetter<HangarGroupUpdateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
hangarGroupUpdateInput = toValue(hangarGroupUpdateInput);

      return axiosClient<HangarGroup>(
      {url: `/hangar/groups/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: hangarGroupUpdateInput, signal
    },
      );
    }




export const getUpdateHangarGroupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarGroup>>, TError,{id: string;data: HangarGroupUpdateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateHangarGroup>>, TError,{id: string;data: HangarGroupUpdateInput}, TContext> => {

const mutationKey = ['updateHangarGroup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHangarGroup>>, {id: string;data: HangarGroupUpdateInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateHangarGroup(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHangarGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updateHangarGroup>>>
    export type UpdateHangarGroupMutationBody = HangarGroupUpdateInput
    export type UpdateHangarGroupMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary HangarGroup Update
 */
export const useUpdateHangarGroup = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarGroup>>, TError,{id: string;data: HangarGroupUpdateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateHangarGroup>>,
        TError,
        {id: string;data: HangarGroupUpdateInput},
        TContext
      > => {
      return useMutation(getUpdateHangarGroupMutationOptions(options), queryClient);
    }
